import { InjectionKey } from 'vue';
import { ModalDefinition } from '@/stores/modals';
import { ModalControls } from './types';

export const MODAL_DEFINITION_KEY = Symbol() as InjectionKey<ModalDefinition>;
export const MODAL_CONTROLS_KEY = Symbol() as InjectionKey<ModalControls>;
